// imports from modules
import { Tab, Nav } from "react-bootstrap";
import Slider from "react-slick";

// components imports
import Login from "../Component/Login";
import Newsflash from "../Component/Newsflash";

// image imports
import logo from "../assets/img/logo.png";

export const LandingPage = () => {
  const settings = {
    dots: true,
    autoplay: true,
    autoplaySpeed: 2500,
    infinite: true,
    // speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // nextArrow: <ArrowBackIcon />,
    // prevArrow: <ArrowForwardIcon />,
  };
  return (
    <div>
      <div>
        <Newsflash />
      </div>
      {/* nav */}
      <div className='landingPage-Nav_Wrap'>
        <div className='landingPage-Nav-Cont'>
          {/* <nav>
            <img src={logo} alt='' className='landingPage-Nav-Logo' />
          </nav> */}
        </div>
      </div>

      {/* carousel */}
      <div className='carousel-Wrapper'>
        <Slider {...settings}>
          <div>
            <div className='carousel-Slides carousel-Slide1' />
          </div>
          <div>
            <div className='carousel-Slides carousel-Slide2' />
          </div>
          <div>
            <div className='carousel-Slides carousel-Slide3' />
          </div>
        </Slider>
      </div>

      {/* tabs */}
      <div style={{ marginTop: '-18%' }}>
        <div className='col-md-6 landingPage-Tabs-Wrap'>
          <div className='ms-panel ms-panel-fh landingPage-Tabs-Cont'>
            <div className='ms-panel-body clearfix'>
              {/* <Tab.Container defaultActiveKey='login'> */}
              {/* <Nav variant='tabs' className='nav nav-tabs d-flex nav-justified mb-4'>
                  <Nav.Item>
                    <Nav.Link eventKey='login'>Login</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey='profile'>Profile</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey='settings'>Settings</Nav.Link>
                  </Nav.Item>
                </Nav> */}
              {/* <Tab.Content>
                  <Tab.Pane eventKey='login'>
                    <Login />
                  </Tab.Pane>
                  <Tab.Pane eventKey='profile'>tab 2 </Tab.Pane>
                  <Tab.Pane eventKey='settings'>tab 3</Tab.Pane>
                </Tab.Content>
              </Tab.Container> */}
              <Login />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
